import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Lock } from "lucide-react";

export const PageHeader = ({ title, subtitle, back }) => {
  const navigate = useNavigate();
  return (
    <header className="fade-up px-5 pt-5 pb-5">
      <div className="relative flex items-center justify-center md:min-h-9">
        {back && (
          <button data-testid="back-button" onClick={() => navigate(-1)} className="absolute left-0 flex h-9 w-9 items-center justify-center rounded-full border border-[#E6A45D]/40 text-[#F8C872] transition-colors hover:bg-[#1D140B]">
            <ChevronLeft size={18} />
          </button>
        )}
        <img src="/img/logo.webp" alt="enjoythismoment" className="h-20 w-auto" />
      </div>
      <h1 data-testid="page-title" className="mt-6 text-base md:text-lg font-semibold uppercase tracking-[0.08em] gold-text">{title}</h1>
      {subtitle && <p className="mt-2 text-sm text-[#F7F4EE]/70">{subtitle}</p>}
      <div className="mt-4 h-px w-16 bg-[#E6A45D]/60" />
    </header>
  );
};

export const SignInPrompt = ({ text }) => (
  <div data-testid="signin-prompt" className="card-dark fade-up mx-5 flex flex-col items-center gap-4 p-8 text-center">
    <span className="gold-ring flex h-14 w-14 items-center justify-center rounded-full text-[#F8C872]"><Lock size={22} strokeWidth={1.5} /></span>
    <p className="text-sm text-[#F7F4EE]/80">{text}</p>
    <Link to="/sign-in" data-testid="signin-prompt-button" className="btn-gold h-12 w-full text-sm">Se connecter</Link>
    <Link to="/sign-up" data-testid="signup-prompt-link" className="text-xs text-[#F6D7A1]/80 underline-offset-4 hover:underline">Créer un compte</Link>
  </div>
);

export const Empty = ({ text, testid }) => (
  <p data-testid={testid} className="mx-5 rounded-[20px] border border-dashed border-[#E6A45D]/30 p-8 text-center text-sm text-[#F7F4EE]/60">{text}</p>
);

export const Loader = () => (
  <div className="flex justify-center py-12"><span className="h-8 w-8 animate-spin rounded-full border-2 border-[#E6A45D]/30 border-t-[#F8C872]" /></div>
);

export const StatusBadge = ({ status, label }) => {
  const tone = { acceptee: "border-[#F8C872] text-[#F8C872]", confirmed: "border-[#F8C872] text-[#F8C872]", refusee: "border-[#F7F4EE]/30 text-[#F7F4EE]/50", cancelled: "border-[#F7F4EE]/30 text-[#F7F4EE]/50", en_cours: "border-[#F6D7A1]/60 text-[#F6D7A1]" }[status] || "border-[#E6A45D]/60 text-[#E6A45D]";
  return <span data-testid={`status-${status}`} className={`rounded-full border px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.1em] ${tone}`}>{label}</span>;
};
